type DetailsValue = string | number;

export const detailsValueFormatter = (
  value?: DetailsValue | null,
  formatter?: (formatterValue: DetailsValue) => string
): string => {
  if (!value) {
    return '-';
  }

  if (!formatter) {
    return value.toString();
  }

  return formatter(value);
};

export const reportDetailsFilterValuesFormatter = (
  values: string[],
  formatter?: (formatterValue: string) => string
): string => {
  if (values.length <= 0) {
    return '< All >';
  }

  return formatter ? values.map((value: string) => formatter(value)).join(', ') : values.join(', ');
};
